export default function accordionOpenScrollToTop() {

  // On accordion open scroll opened element to top
$('.accordion-collapse').on('shown.bs.collapse', function (e) {
    var $accordionCard = $(this).closest('.accordion-card');
    $('html,body').animate({
        scrollTop: $accordionCard.offset().top - 20
    }, 500);
});
}